import {defaultAxios, IParams} from "../base";

interface IFetchSelectApartmentPrice extends IParams{
    // apartment: string; // 물건 코드
}

export const fetchSelectApartmentPrice = async (parmas:IFetchSelectApartmentPrice) => {
    return await defaultAxios().post('/base/selectApartmentPrice', parmas)
}